import {OFFER_INFO_DESCRIPTION_GENERATED_CONTENT} from "../constants/offer_info_description_generated_content";
import {IOffer} from "../types/property/IOffer";
import {VendorType} from "../types/property/IVendor";
import {actualStreetNameCheck} from "./actual_street_name_check";

function getDistanceFromRegionDescription(offer: IOffer) {
    const distanceFromRegion = offer.stats?.distance_from_region;

    if (!distanceFromRegion || distanceFromRegion.distance <= 0) return "";

    const {CENTER, DISTANCE_KM_FROM} = OFFER_INFO_DESCRIPTION_GENERATED_CONTENT;
    const centerLabel = distanceFromRegion.center ? `${CENTER} ` : "";

    return ` (${distanceFromRegion.distance} ${DISTANCE_KM_FROM} ${centerLabel}${distanceFromRegion.region}),`;
}

function getInvestorNameSuffix(investorOrVendorName: string) {
    return investorOrVendorName.endsWith(".") ? "" : ".";
}

function getStreetDescriptionParts(offer: IOffer) {
    const hasRealStreetName = Boolean(offer.street_name) && actualStreetNameCheck(offer.street_name);

    return {
        address: hasRealStreetName ? `${offer.street_name} ${offer.street_number || ""}` : "",
        separator: hasRealStreetName ? ", " : " "
    };
}

function getVendorDescription(offer: IOffer, constructionDateDiffDays: number) {
    const {AGENCY_SALES_PREFIX, DEVELOPER_BY, DEVELOPER_COMPLETED, DEVELOPER_IN_PROGRESS} = OFFER_INFO_DESCRIPTION_GENERATED_CONTENT;
    const investorOrVendorName = offer.investor || offer.vendor.name;
    const nameSuffix = getInvestorNameSuffix(investorOrVendorName);

    if (offer.vendor.type === VendorType.DEVELOPER) {
        const developerStatus = constructionDateDiffDays <= 0 ? DEVELOPER_IN_PROGRESS : DEVELOPER_COMPLETED;
        const developerName = offer.investor ?? offer.vendor.name;

        return `${developerStatus} ${DEVELOPER_BY} ${developerName}${nameSuffix}`;
    }

    if (offer.vendor.type === VendorType.AGENCY) {
        return ` ${AGENCY_SALES_PREFIX} ${offer.vendor.name}${nameSuffix}`;
    }

    return "";
}

export function getOfferGenericDescription(offer: IOffer, regionNameDeclensionWhere: string, constructionDateDiffDays: number) {
    const {INVESTMENT_PREFIX, LOCATION_VERB} = OFFER_INFO_DESCRIPTION_GENERATED_CONTENT;
    const {address, separator} = getStreetDescriptionParts(offer);
    const distanceDescription = getDistanceFromRegionDescription(offer);
    const vendorDescription = getVendorDescription(offer, constructionDateDiffDays);

    return `${INVESTMENT_PREFIX} ${offer.name} ${LOCATION_VERB} ${regionNameDeclensionWhere}${separator} ${address}${distanceDescription} ${vendorDescription}`;
}
import {OFFER_INFO_DESCRIPTION_GENERATED_CONTENT} from "../constants/offer_info_description_generated_content";
import {IOffer} from "../types/property/IOffer";
import {VendorType} from "../types/property/IVendor";
import {actualStreetNameCheck} from "./actual_street_name_check";

function getDistanceFromRegionDescription(offer: IOffer) {
    const distanceFromRegion = offer.stats?.distance_from_region;

    if (!distanceFromRegion || distanceFromRegion.distance <= 0) return "";

    const {CENTER, DISTANCE_KM_FROM} = OFFER_INFO_DESCRIPTION_GENERATED_CONTENT;
    const centerLabel = distanceFromRegion.center ? `${CENTER} ` : "";

    return ` (${distanceFromRegion.distance} ${DISTANCE_KM_FROM} ${centerLabel}${distanceFromRegion.region}),`;
}

function getInvestorNameSuffix(investorOrVendorName: string) {
    return investorOrVendorName.endsWith(".") ? "" : ".";
}

function getStreetDescriptionParts(offer: IOffer) {
    const hasRealStreetName = Boolean(offer.street_name) && actualStreetNameCheck(offer.street_name);

    return {
        address: hasRealStreetName ? `${offer.street_name} ${offer.street_number || ""}` : "",
        separator: hasRealStreetName ? ", " : " "
    };
}

function getVendorDescription(offer: IOffer, constructionDateDiffDays: number) {
    const {AGENCY_SALES_PREFIX, DEVELOPER_BY, DEVELOPER_COMPLETED, DEVELOPER_IN_PROGRESS} = OFFER_INFO_DESCRIPTION_GENERATED_CONTENT;
    const investorOrVendorName = offer.investor || offer.vendor.name;
    const nameSuffix = getInvestorNameSuffix(investorOrVendorName);

    if (offer.vendor.type === VendorType.DEVELOPER) {
        const developerStatus = constructionDateDiffDays <= 0 ? DEVELOPER_IN_PROGRESS : DEVELOPER_COMPLETED;
        const developerName = offer.investor ?? offer.vendor.name;

        return `${developerStatus} ${DEVELOPER_BY} ${developerName}${nameSuffix}`;
    }

    if (offer.vendor.type === VendorType.AGENCY) {
        return ` ${AGENCY_SALES_PREFIX} ${offer.vendor.name}${nameSuffix}`;
    }

    return "";
}

export function getOfferGenericDescription(offer: IOffer, regionNameDeclensionWhere: string, constructionDateDiffDays: number) {
    const {INVESTMENT_PREFIX, LOCATION_VERB} = OFFER_INFO_DESCRIPTION_GENERATED_CONTENT;
    const {address, separator} = getStreetDescriptionParts(offer);
    const distanceDescription = getDistanceFromRegionDescription(offer);
    const vendorDescription = getVendorDescription(offer, constructionDateDiffDays);

    return `${INVESTMENT_PREFIX} ${offer.name} ${LOCATION_VERB} ${regionNameDeclensionWhere}${separator} ${address}${distanceDescription} ${vendorDescription}`;
}
